import "../../styles/landing/Page7.css";

const Page7 = () => {
  return (
    <div className="page7-wrapper">
      <h2 className="page7-title">Fotographiya is Everywhere!</h2>
      <p className="page7-subtitle">
        Sharing and celebrating your memories everyday
      </p>
      <div className="highlight-line"></div>
      <div className="collage-container">
        <img src="/image/page7.jpg" alt="Fotographiya Collage" />
      </div>
    </div>
  );
};

export default Page7;
